import React, {useEffect, useState} from "react";
import {Badge, Nav, Navbar, NavItem} from "reactstrap";
import {NavLink, useHistory} from "react-router-dom";
import {connect} from "react-redux";
import {IStore} from "../../redux/defaultStore";
import {addError, logout, toggleSideBar} from "../../redux/meta/MetaActions";
import AssetManager from "../assetManager/AssetManager";
import TournamentList from "./TournamentList";
import {UserApi} from "client";
import getConfig from "../../utils/getConfig";

interface IProps {
	token?: string;
	dispatch?: any;
	sideBarVisible?: boolean;
}

const SideBarInner: React.FC<IProps> = (props: IProps) => {

	const history = useHistory();
	const [showAssetManager, setShowAssetManager] = useState();
	const [isDemoAccount, setIsDemoAccount] = useState(false);

	useEffect(() => {
		if (props.token) {
			checkIfDemo().then().catch();
		}
	}, [props.token]);

	async function checkIfDemo(): Promise<void> {
		try {
			const res = await new UserApi(getConfig(props.token)).isDemoAccount();
			setIsDemoAccount(res === "true");
		} catch (e) {
			props.dispatch(addError(e));
		}
	}

	function toggleAssetManager(e): void {
		if (e) {
			e.preventDefault();
		}
		setShowAssetManager(!showAssetManager);
	}

	function closeSideBarHelper(): void {
		if (props.sideBarVisible) {
			props.dispatch(toggleSideBar(false));
		}
	}

	function logoutDispatcher(e): void {
		if (e) {
			e.preventDefault();
		}

		closeSideBarHelper();
		props.dispatch(logout());
		history.push("/");
	}

	return (
		<React.Fragment>
			<div className="w-100">
				<Navbar color="black" dark>
					<Nav navbar className="w-100">

						<a href="https://iscoregolfplus.com/" target="_blank" rel="noreferrer noopener">
							<div className="align-items-start">
								<img
									src={process.env.PUBLIC_URL + "/images/iscore-golf-logo.png"}
									style={{objectFit: "contain", maxWidth: "100%"}}
								/>
							</div>
						</a>

						{isDemoAccount && (
							<div className="my-2 w-100">
								<Badge color="warning" pill className="w-100" style={{fontSize: "1rem"}}>Demo Account</Badge>
							</div>
						)}

						<NavItem>
							<NavLink exact to="/iscoregolfplus" onClick={closeSideBarHelper}
							         className="text-decoration-none nav-link">iScoreGolf Plus</NavLink>
						</NavItem>

						<NavItem>
							<NavLink exact to="/create-tournament" onClick={closeSideBarHelper}
							         className="text-decoration-none nav-link">Create Tournament</NavLink>
						</NavItem>

						{/*<NavItem>*/}
						{/*	<a href="#" onClick={toggleAssetManager} className="nav-link">*/}
						{/*		Open Asset Manager*/}
						{/*	</a>*/}
						{/*</NavItem>*/}

						<div className="my-3">
							<TournamentList/>
						</div>

						{props.token && (
							<NavItem>
								<a href="#" onClick={logoutDispatcher} className="nav-link text-danger">
									Logout
								</a>
							</NavItem>
						)}

						<div className="text-white" style={{fontSize: "0.85rem"}}>
							<hr className="bg-white"/>
							<p className="mb-0">
								{process.env.REACT_APP_PROJECT_NAME}
							</p>
							<p className="mb-0">
								{process.env.REACT_APP_VERSION}
							</p>
						</div>
					</Nav>
				</Navbar>
			</div>
		</React.Fragment>
	);
};

export default connect((store: IStore, props: IProps) => {
	return {
		...props,
		token: store.metaStore.token,
		sideBarVisible: store.metaStore.sidebarVisible,
	}
})(SideBarInner);
